export default "__VITE_ASSET__ZvAuXuBh__"